export default __webpack_public_path__ + "static/media/star.fde4d0f5.png";